import { CanvasData, ImageData, Triangle, Point } from "@/types";
import {
    getLongestSide,
    splitTriangle,
    updateDeviation,
    updateColor,
    updatePixels,
} from "@/tools/triangle";
import { addPointInbetween } from "@/tools/point";

export const updateTriangles = (
    canvasData: CanvasData,
    triangles: Triangle[],
    imageData: ImageData,
    correction: number
) => {
    const fresh = triangles.filter((t) => t.fresh);
    for (const triangle of fresh) {
        updatePixels(triangle, canvasData);
        updateColor(triangle, imageData);
        updateDeviation(triangle, imageData, correction);
        triangle.fresh = false;
    }
};

export const splitWorstTriangle = (triangles: Triangle[]) => {
    const triangleWithHighestDeviation = triangles.reduce((prev, current) =>
        prev.deviation > current.deviation ? prev : current
    );
    const longest = getLongestSide(triangleWithHighestDeviation);
    const oldTriangles = findMatchingTriangles(
        triangles,
        longest[0],
        longest[1]
    );
    const newPoint = addPointInbetween(longest[0], longest[1]);
    const newTriangles = createNewTriangles(
        oldTriangles,
        newPoint,
        longest[0],
        longest[1]
    );
    return {
        newPoint,
        newTriangles,
        oldTriangles,
    };
};

const createNewTriangles = (
    oldTriangles: Triangle[],
    newPoint: Point,
    oldPoint1: Point,
    oldPoint2: Point
) => {
    const newTriangles: Triangle[] = [];
    if (oldTriangles.length > 0) {
        const newTriangles1 = splitTriangle(
            oldTriangles[0],
            newPoint,
            oldPoint1,
            oldPoint2
        );
        oldTriangles[0].active = false;
        newTriangles.push(...newTriangles1);

        if (oldTriangles.length > 1) {
            const newTriangles2 = splitTriangle(
                oldTriangles[1],
                newPoint,
                oldPoint1,
                oldPoint2
            );
            newTriangles.push(...newTriangles2);
            oldTriangles[1].active = false;
        }
    }
    return newTriangles;
};

const findMatchingTriangles = (triangles: Triangle[], a: Point, b: Point) => {
    const sameTriangles = [];
    for (const triangle of triangles) {
        if (
            (triangle.A === a || triangle.B === a || triangle.C === a) &&
            (triangle.A === b || triangle.B === b || triangle.C === b)
        ) {
            sameTriangles.push(triangle);
        }
    }
    return sameTriangles;
};
